import React from 'react'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '../ui/button'
import { TrashIcon, XMarkIcon } from '@heroicons/react/16/solid'
import { Separator } from '../ui/separator'
import useDeleteMoneyPath from '@/services/api/money-path/useDeleteMoneyPath'
import { useNavigate } from 'react-router-dom'
export default function DeleteMoneyPathModal({ id }: { id: number }) {
  const { action: deleteRule, status } = useDeleteMoneyPath({ id })

  const navigate = useNavigate()

  async function deleteMoneyPath() {
    await deleteRule()
    navigate('/money-paths')
  }
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button iconOnly variant="ghost">
          <TrashIcon className="text-txt-error" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Money Path</DialogTitle>
          <DialogClose>
            <XMarkIcon />
          </DialogClose>
        </DialogHeader>

        <DialogBody>
          <p>Are you sure, you want to delete?</p>
        </DialogBody>

        <DialogFooter>
          <Button
            type="button"
            variant="destructive"
            onClick={deleteMoneyPath}
            loading={status.status === 'pending'}
          >
            Yes
          </Button>

          <DialogClose asChild>
            <Button type="button" variant="secondary">
              No
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
